import { render, staticRenderFns } from "./OptimizationErrors.vue?vue&type=template&id=64aded88"
import script from "./OptimizationErrors.vue?vue&type=script&lang=js"
export * from "./OptimizationErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports